module.exports = __webpack_public_path__ + "static/img/samajuri (4).96aab0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (4).jpg
// module id = xNdu
// module chunks = 0